import RestService from "@/services/RestService";

function getCalendar(start, end) {
  const data = {
    dateFrom: start,
    dateTo: end,
    types: "lesson,school_event,holiday",
  };
  return RestService.sendReq("get", "student/diary/events", data);
}

export default {
  getCalendar,
};
